import React from 'react'
import Avatar from 'components/SA/Avatar'
import styles from '../ArtAdvisory.module.scss'
type Props = {
  data: Record<string, any>
}

const Component = ({ data }: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const { name, title, collectionUrl, image } = data
  return (
    <div className={styles.teamMember}>
      <div className={styles.content}>
        <div className={styles.image}>
          <Avatar
            width='180'
            height='180'
            image={image}
            shape='round'
            styleOverride={styles.curatorAvatar}
            alt={`Saatchi Art Advisory - ${name}`}
          />
        </div>
        <div className={styles.bio}>
          <div className={styles.bioContent}>
            <p className={`${styles.name} defaultTypographyH5`}>{name}</p>
            <p className={`${styles.title} defaultTypographySmall`}>{title}</p>
            <a
              className={`${styles.profileLink} defaultTypographyCtaMedium defaultTextUppercase`}
              href={collectionUrl}
            >
              See Curator's Favorites
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Component
